/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WidgetsPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABMklEQVR4nN1US04DMQzNiiVHKKI9C6iicWxGimwNt+B7hA49ViuOUugVhk2Roa3CNDNpBhCIJ3mVFz//jfnLIOIRoNxb5Ftr/aCT7L0/csSPgPzsSNZbA+KlI6n0PeRb4nNAft3xUGpAmY3HV8dRAXUSOo5YteWqE0e8ivN4peJ7AptIWwWAeLnjosw6uSj1pCiHzQzWKTPGmIuiPFEHKa72ppcAoNwcwnXE1z0F+OGA6GvNtFcPJkU5TJVIe5Q9RYAyDUe0a4qio/qxB1I1M4GWPVAnGmmYzfsuXMqZ+U5Y6we6yY74DsCfml+DzzwV2cg5FTEAyZNDXrQTGpHvGcpL6+dgj5KE1KL9HwHQmqf+hD3JOdcK/Zy8SSTzXqeiV4lyT4XJFfgqfl4AefGp5hu8AZx0EjVpMYglAAAAAElFTkSuQmCC)
 */
export const WidgetsPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.45 1.85a3 3 0 0 0-4.1 1.1l-1.5 2.6a3 3 0 0 0 1.1 4.1l2.6 1.5a3 3 0 0 0 4.1-1.1l1.5-2.6a3 3 0 0 0-1.1-4.1l-2.6-1.5ZM2 5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5ZM2 16a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3ZM19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
